module.exports = {
          srcSet: __webpack_public_path__ + "1f3a348094128c3d6799076e33430da6-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "1f3a348094128c3d6799076e33430da6-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "1f3a348094128c3d6799076e33430da6-24.png",
          toString:function(){return __webpack_public_path__ + "1f3a348094128c3d6799076e33430da6-24.png"},
          
          width: 24,
          height: 24
        }